var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert',{attrs:{"unclosable":true,"icon":"fa-lock","classes":"alert-warning","message":"This feature is unavailable in the Free Tier","visible":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }